import type { AxiosResponse } from "axios";
import { InitService } from "./init.service";
import type FiltroPadrao from "./model/filtroPadrao";
import type Item from "./model/item";

export class ConfigService extends InitService {
    async carregarFiltroPadrao(): Promise<AxiosResponse<FiltroPadrao>> {
        return await this.get('ConfiguracaoPadrao/ObterPesquisaPadrao', true);
    }
    async carregarDepartamentos(): Promise<AxiosResponse<Array<Item>>> {
        return await this.post('ConfiguracaoPadrao/ObterDepartamentos', null, true);
    }
}

const configService = new ConfigService();

export default configService;